import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Pressable, View } from 'react-native';
import { BLACK_600, BLACK_700, BLUE_500, GREEN_500, LILAC_400, tokens, WHITE } from '../../constants';
import { useBreakpoint } from '../../hooks/useBreakpoint';
import { StateConfigContext } from '../../providers';
import { checkIsPlatform, getTestId, isLastItem, isValidObject } from '../../utils';
import { Avatar } from '../avatar';
import { Button } from '../button/Button';
import { Divider } from '../divider/Divider';
import { DynamicSvg } from '../dynamic-svg';
import { IconButton } from '../icon-button';
import { InfoTag } from '../info-tag';
import { Progress } from '../progress/Progress';
import { Typography } from '../typography/Typography';
import { getKeyPairStatusColors, getKeyPairUnitProps, getKeyPairUnitStyles } from './KeyPairUnitStyles';
export var KeyPairUnit = props => {
  var _getKeyPairUnitProps = getKeyPairUnitProps(props, useContext(StateConfigContext)),
    data = _getKeyPairUnitProps.data,
    style = _getKeyPairUnitProps.style,
    _getKeyPairUnitProps$ = _getKeyPairUnitProps.testID,
    testID = _getKeyPairUnitProps$ === void 0 ? 'keyPairUnit' : _getKeyPairUnitProps$,
    column = _getKeyPairUnitProps.column,
    layout = _getKeyPairUnitProps.layout,
    _showDividerProp = _getKeyPairUnitProps.showDivider,
    _valueAsBoldProp = _getKeyPairUnitProps.valueAsBold,
    onCopyIconPress = _getKeyPairUnitProps.onCopyIconPress,
    onTertiaryCtaPress = _getKeyPairUnitProps.onTertiaryCtaPress,
    onButtonPress = _getKeyPairUnitProps.onButtonPress,
    innerContainerStyle = _getKeyPairUnitProps.innerContainerStyle,
    onIconButtonPress = _getKeyPairUnitProps.onIconButtonPress,
    parentAccessibilityProps = _getKeyPairUnitProps.parentAccessibilityProps;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var keyPairUnitStyles = getKeyPairUnitStyles(props, isLargeScreen);
  var _width = 100 / column;
  var columnAsOne = column === 1;
  if (!(data === null || data === void 0 ? void 0 : data.length)) return null;
  var onIconClick = (event, itemData, index) => {
    var _a, _b;
    if (itemData.showCopyIcon) {
      if (checkIsPlatform('web')) {
        if ('clipboard' in navigator) {
          navigator.clipboard.writeText(itemData.value);
        }
      }
    }
    (_b = (_a = itemData.iconButtonProps) === null || _a === void 0 ? void 0 : _a.onPress) === null || _b === void 0 ? void 0 : _b.call(_a, event, itemData);
    onCopyIconPress === null || onCopyIconPress === void 0 ? void 0 : onCopyIconPress(event, itemData, index);
  };
  return _jsx(View, Object.assign({
    style: [keyPairUnitStyles.container, style]
  }, parentAccessibilityProps, getTestId(testID, 'container'), {
    children: data === null || data === void 0 ? void 0 : data.map((itemData, index) => {
      var description = itemData.description,
        descStatus = itemData.descStatus,
        showCopyIcon = itemData.showCopyIcon,
        iconButtonProps = itemData.iconButtonProps,
        infoTagProps = itemData.infoTagProps,
        progressBarProps = itemData.progressBarProps,
        buttonProps = itemData.buttonProps,
        tertiaryCtaProps = itemData.tertiaryCtaProps,
        keyProps = itemData.keyProps,
        valueProps = itemData.valueProps,
        discountAmount = itemData.discountAmount,
        showDivider = itemData.showDivider,
        key = itemData.key,
        savedAmount = itemData.savedAmount,
        value = itemData.value,
        valueAsBold = itemData.valueAsBold,
        logoProps = itemData.logoProps;
      var isLastRow = Math.ceil((index + 1) / column) === Math.ceil((data === null || data === void 0 ? void 0 : data.length) / column);
      var isLastColumn = (index + 1) % column === 0;
      var isValueBold = valueAsBold !== null && valueAsBold !== void 0 ? valueAsBold : _valueAsBoldProp;
      return _jsx(View, Object.assign({
        style: [keyPairUnitStyles.container, {
          width: _width + "%"
        }, layout === 'vertical' ? !isLastItem(data, index) && {
          paddingBottom: isLargeScreen ? tokens.spacing.SPACING_16 : tokens.spacing.SPACING_12
        } : !isLastRow && {
          paddingBottom: tokens.spacing.SPACING_12
        }, !isLastItem(data, index) && !isLastColumn && {
          paddingRight: tokens.spacing.SPACING_16
        }, layout === 'vertical' && {
          marginRight: tokens.spacing.SPACING_4
        }, innerContainerStyle]
      }, getTestId(testID), {
        children: _jsxs(View, Object.assign({
          style: [columnAsOne ? {
            width: _width + "%"
          } : keyPairUnitStyles.fullWidth]
        }, {
          children: [_jsxs(View, Object.assign({
            style: keyPairUnitStyles.flexDirectionRow
          }, {
            children: [_jsxs(View, Object.assign({
              style: [columnAsOne ? {
                width: _width + "%"
              } : keyPairUnitStyles.fullWidth, isValidObject(logoProps) && keyPairUnitStyles.logoStyle]
            }, {
              children: [_jsx(View, Object.assign({
                style: [keyPairUnitStyles.flexDirectionRow, columnAsOne && keyPairUnitStyles.fullWidth]
              }, {
                children: _jsxs(View, Object.assign({
                  style: [keyPairUnitStyles.keyValueContainer, columnAsOne ? {
                    width: _width + "%"
                  } : keyPairUnitStyles.fullWidth]
                }, {
                  children: [(key || savedAmount || isValidObject(keyProps)) && _jsxs(View, Object.assign({
                    style: [keyPairUnitStyles.keyContainer, layout === 'horizontal' && isValidObject(iconButtonProps) && {
                      marginTop: -5
                    }]
                  }, {
                    children: [_jsx(Typography, Object.assign({
                      color: BLACK_700
                    }, keyProps, {
                      type: "body-single-line-xs",
                      text: key
                    })), savedAmount && _jsx(Typography, {
                      color: GREEN_500,
                      type: "body-single-line-xs-bold",
                      text: savedAmount,
                      style: keyPairUnitStyles.leftSafeSpacing
                    })]
                  })), _jsxs(View, Object.assign({
                    style: [keyPairUnitStyles.valueContainer, !columnAsOne && {
                      alignItems: 'flex-start'
                    }]
                  }, {
                    children: [_jsxs(View, Object.assign({
                      style: keyPairUnitStyles.valueDiscountContainer
                    }, {
                      children: [(value || isValidObject(valueProps)) && _jsx(Typography, Object.assign({
                        type: "body-para-sm" + (isValueBold ? '-bold' : '')
                      }, valueProps, {
                        text: value
                      })), discountAmount && _jsx(Typography, {
                        text: discountAmount,
                        isStriked: true,
                        color: BLACK_600,
                        type: "body-para-sm",
                        style: [keyPairUnitStyles.leftSafeSpacing, {
                          fontSize: 14
                        }]
                      })]
                    })), isValidObject(tertiaryCtaProps) && _jsx(Button, Object.assign({}, tertiaryCtaProps, {
                      buttonType: 'tertiary',
                      style: [keyPairUnitStyles.leftSafeSpacing, {
                        alignSelf: 'center'
                      }],
                      onPress: event => {
                        var _a;
                        if (tertiaryCtaProps === null || tertiaryCtaProps === void 0 ? void 0 : tertiaryCtaProps.onPress) {
                          (_a = tertiaryCtaProps === null || tertiaryCtaProps === void 0 ? void 0 : tertiaryCtaProps.onPress) === null || _a === void 0 ? void 0 : _a.call(tertiaryCtaProps, event);
                        }
                        onTertiaryCtaPress === null || onTertiaryCtaPress === void 0 ? void 0 : onTertiaryCtaPress(itemData, index);
                      }
                    })), showCopyIcon && isValidObject(iconButtonProps) && _jsx(Pressable, Object.assign({
                      onPress: event => {
                        onIconClick(event, itemData, index);
                      },
                      style: keyPairUnitStyles.iconContainer
                    }, {
                      children: _jsx(DynamicSvg, {
                        iconName: 'CopyIcon',
                        color: BLUE_500
                      })
                    })), isValidObject(iconButtonProps) && _jsx(View, {
                      children: _jsx(IconButton, Object.assign({
                        noBgColor: true,
                        type: 'secondary',
                        noContainer: true
                      }, iconButtonProps, {
                        onPress: event => {
                          if (iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onPress) {
                            iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onPress(event);
                          }
                          onIconButtonPress === null || onIconButtonPress === void 0 ? void 0 : onIconButtonPress(itemData, index);
                        }
                      }, getTestId(testID, "iconButton_" + index)))
                    })]
                  }))]
                }))
              })), isValidObject(logoProps) && _jsx(View, Object.assign({
                style: keyPairUnitStyles.avatarImgStyles
              }, {
                children: _jsx(Avatar, Object.assign({
                  variant: "image"
                }, Object.assign(Object.assign({}, logoProps), {
                  imageProps: Object.assign({}, logoProps === null || logoProps === void 0 ? void 0 : logoProps.imageProps)
                })))
              })), description && _jsx(View, Object.assign({
                style: keyPairUnitStyles.topMarginContainer
              }, {
                children: _jsx(Typography, {
                  type: "body-para-sm",
                  color: getKeyPairStatusColors(descStatus).color,
                  text: description
                })
              }))]
            })), (showDivider || _showDividerProp) && !isLastItem(data, index) && _jsx(Divider, {
              isVertical: true,
              height: 2,
              color: LILAC_400,
              shadowColor: WHITE,
              style: keyPairUnitStyles.divider
            })]
          })), isValidObject(progressBarProps) && _jsx(View, Object.assign({
            style: keyPairUnitStyles.topMarginContainer
          }, {
            children: _jsx(Progress, Object.assign({
              type: "linear"
            }, progressBarProps, getTestId(testID, "progressBar_" + index)))
          })), isValidObject(infoTagProps) && _jsx(InfoTag, Object.assign({
            size: "sm"
          }, infoTagProps, getTestId(testID, index + "_infoTag"), {
            style: keyPairUnitStyles.topMarginContainer
          })), isValidObject(buttonProps) && _jsx(View, Object.assign({
            style: keyPairUnitStyles.topMarginContainer
          }, {
            children: _jsx(Button, Object.assign({}, buttonProps, {
              buttonType: 'tertiary',
              testID: "tertiaryCta_" + index,
              onPress: event => {
                var _a;
                if (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onPress) {
                  (_a = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.onPress) === null || _a === void 0 ? void 0 : _a.call(buttonProps, event);
                }
                onButtonPress === null || onButtonPress === void 0 ? void 0 : onButtonPress(itemData, index);
              }
            }))
          }))]
        }))
      }), key + "-" + index);
    })
  }));
};